// extracted by mini-css-extract-plugin
export default {"form":"form_form__sP2jI","centered":"form_centered__SKhgE"};